import React, { useEffect, useState } from "react";

interface LogoProps {
  variant?: "dark" | "light";
  animated?: boolean;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({
  variant = "dark",
  animated = false,
  className = ""
}) => {
  const [showLogo, setShowLogo] = useState(!animated);
  const [showTagline, setShowTagline] = useState(!animated);

  useEffect(() => {
    if (animated) {
      const logoTimer = setTimeout(() => setShowLogo(true), 200);
      const taglineTimer = setTimeout(() => setShowTagline(true), 400);
      return () => {
        clearTimeout(logoTimer);
        clearTimeout(taglineTimer);
      };
    }
  }, [animated]);

  const isDark = variant === "dark";
  const titleColor = isDark ? "text-[#344054]" : "text-white";
  const taglineColor = isDark ? "text-[#344054]" : "text-blue-100";

  return (
    <div className={className}>
      <div
        className={`transform transition-all duration-500 ease-out ${
          showLogo ? "translate-x-0 opacity-100" : "-translate-x-8 opacity-0"
        }`}
      >
        <span className={`text-3xl ${titleColor} uppercase font-extrabold block drop-shadow-lg`}>
          Autobiz<span className="text-blue-300">.hr</span>
        </span>
      </div>
      <p
        className={`text-md ${taglineColor} mt-1 transform transition-all duration-500 ease-out ${
          showTagline ? "translate-x-0 opacity-100" : "-translate-x-8 opacity-0"
        }`}
      >
        tehnologija koja pokreće flotu
      </p>
    </div>
  );
};

export default React.memo(Logo);
